(function($) {  
    var comment_load_more = {
        _post: null,
        _order: 'desc',
        _ajaxurl: valtiolla.ajaxurl,
        _pages: null,
        _page: null,
        button: null,
        el: $("#comments"),
        fetch: function(event){
            this.button = $(event.target);
            this._post = this.button.data("post");
            this._order = this.button.data("order");
            this._pages = this.button.data("pages");
            this._page = this.button.data("page");
            this.el = $("#comments-body"),
            this.handleFetch();
        },
        handleFetch: function(){
            var page = this.button.attr("data-page");
            var _next = this.nextPage(page);
            if (!_next)
                return;


            $.ajax({
                url : this._ajaxurl, // AJAX handler, declared before
                data : {
                    'action': 'valtiolla_comment_load_more',
                    'post_id': this._post,
                    'cpage' : _next,
                },
                type : 'POST',
                beforeSend : function ( xhr ) {
                    this.button.prop("disabled", true);
                }.bind(this),
                success : function( data ){
                    if( data ) {
                        this.el.append( data );
                        this.button.removeAttr("disabled");
                        this.button.attr("data-page", _next);
                        this._page = _next;
                         // if the last page, remove the button
                        if ( !this.nextPage(_next) )
                            this.button.remove();
                    } else {
                        this.button.remove();
                    }
                }.bind(this)
            });
            return false;
        },
        nextPage: function(currentPage){
            var nextPage = null;
            if (this._order == "desc"){
                nextPage = currentPage - 1;
            } else{
                nextPage = currentPage + 1;
            }

            if (nextPage > this._pages || nextPage <= 0){
                return false;
            }

            return nextPage;
        }
    }


    $(".valtiolla_comment_load_more").on("click", comment_load_more.fetch.bind(comment_load_more));
    $(document).ready(function(){
        //state.render();
    })
})( jQuery );